window.addEventListener('load', function () {
    let manageConsent = document.querySelector('[data-id="manageCookieConsent"]');
    if (manageConsent) {
        manageConsent.setAttribute('data-modal-open', 'customiseCookiesModal');
    }
    (window as any).ARIAmodal.init();
    initAccordions();
})

let currentURL = window.location.pathname;
let subnavElement = document.querySelector('.sub-nav-list-container ul li a[href="' + currentURL.toLowerCase() + '"]');
if (subnavElement) {
    subnavElement.setAttribute('aria-current', 'page');
}

function initAccordions() {
    var accordionButtons = document.querySelectorAll('.btn[data-toggle="collapse"]');
    if (accordionButtons.length) {
        accordionButtons.forEach(function (toggle) {
            toggle.addEventListener('click', function (e) {
                let elem = e.target as HTMLElement;
                if (elem.getAttribute('aria-expanded') == "false") {
                    elem.setAttribute('aria-expanded', 'true')
                    let target = elem.getAttribute('data-target');
                    if (target) {
                        let targetElem = document.querySelector(target as string);
                        if (targetElem) {
                            targetElem.classList.add('in');
                        }
                    }
                }
                else {
                    elem.setAttribute('aria-expanded', 'false');
                    let target = elem.getAttribute('data-target');
                    if (target) {
                        let targetElem = document.querySelector(target as string);
                        if (targetElem) {
                            targetElem.classList.remove('in');
                        }
                    }
                }
            })
        })
    }
}